export interface FeedbackSubmit {
  feedback_type: string;
  feature: string;
  rating?: number;
  comment: string;
  screenshot_url?: string;
  is_anonymous: boolean;
  page_url?: string;
  browser_info?: string;
}

export interface Feedback {
  id: number;
  feedback_type: string;
  feature: string;
  rating: number | null;
  comment: string;
  screenshot_url: string | null;
  is_anonymous: boolean;
  status: 'new' | 'reviewed' | 'resolved';
  page_url: string | null;
  user_name: string | null;
  user_email: string | null;
  created_at: string;
}

export interface PaginatedFeedback {
  items: Feedback[];
  total: number;
  page: number;
  per_page: number;
}

export const FEEDBACK_FEATURES = [
  'General',
  'Dashboard',
  'Projects',
  'Resources',
  'Governance Tracker',
  'Ask Wave',
  'Tech Request',
  'Project Task Management',
  'Others',
] as const;

export const DEFAULT_FEATURE = 'General';

export interface FeedbackType {
  value: string;
  label: string;
  icon: string;
  color: string;
  description: string;
}

export const FEEDBACK_TYPES: FeedbackType[] = [
  {
    value: 'Feedback',
    label: 'Feedback',
    icon: 'chat_bubble',
    color: '#1a73e8',
    description: 'General thoughts or an overall impression of the app',
  },
  {
    value: 'Suggestion',
    label: 'Suggestion',
    icon: 'lightbulb',
    color: '#f9ab00',
    description: 'An improvement to something that already exists',
  },
  {
    value: 'Bug',
    label: 'Bug',
    icon: 'bug_report',
    color: '#d93025',
    description: 'Something is broken or not working as expected',
  },
  {
    value: 'New feature idea',
    label: 'Feature Idea',
    icon: 'auto_awesome',
    color: '#1e8e3e',
    description: 'A brand-new capability you would like to see',
  },
];

export const DEFAULT_FEEDBACK_TYPE = 'Feedback';

export const FEEDBACK_STATUSES: { value: Feedback['status']; label: string }[] = [
  { value: 'new', label: 'New' },
  { value: 'reviewed', label: 'Reviewed' },
  { value: 'resolved', label: 'Resolved' },
];
